/**
 * Prepositional short-form overrides for use inside running prose
 * ("Anywhere in the UK", "diners in the US"). Other countries read
 * naturally with their canonical name, so they pass through unchanged.
 *
 * Lives in a non-React module so it can be used outside Inertia trees
 * (e.g. the ChefsDashboard / ChefOnboarding SPAs mounted via react-router).
 */
const SHORT_NAME_OVERRIDES: Record<string, string> = {
    'United Kingdom': 'the UK',
    'United States': 'the US',
};

export function shortNameFor(name: string | null | undefined): string {
    if (!name) return '';
    return SHORT_NAME_OVERRIDES[name] ?? name;
}
